const Campaigns = () => import('@/modules/campaigns/index.vue');

export default [
  {
    path: '/franquia/destaques',
    component: Campaigns,
    name: 'franchise-campaign-list',
    meta: {
      navbarTitle: 'Destaques',
      isAvaliableInMenu: false,       
      menuData: {
        title: 'Destaques',
        id: 'campaignsSidebar',
        section: 'Marketing',
        icon: 'star',
      },
    },
  },
  {
    path: '/franquia/destaques/criar',
    name: 'franchise-campaign-create',
    component: Campaigns,
    props: true,
    meta: {
      navbarTitle: 'Criar destaque',
    },
  },
  {
    path: '/franquia/destaques/duplicar/:id',
    name: 'franchise-campaign-duplicate',
    component: Campaigns,
    props: true,
    meta: {
      navbarTitle: 'Duplicar destaque',
    },
  },
  {
    path: '/destaques',
    component: Campaigns,
    name: 'campaign-list',
    meta: {
      navbarTitle: 'Destaques',
      isAvaliableInMenu: true,
      menuData: {
        title: 'Destaques',
        id: 'campaignsSidebar',
        section: 'Marketing',
        icon: 'star',
      },
    },
  },
  {
    path: '/destaques/criar',
    name: 'campaign-create',
    component: Campaigns,
    props: true,
    meta: {
      navbarTitle: 'Criar destaque',
    },
  },
  {
    path: '/destaques/duplicar/:id',
    name: 'campaign-duplicate',
    component: Campaigns,
    props: true,
    meta: {
      navbarTitle: 'Duplicar destaque',
    },
  },
];
